export default __webpack_public_path__ + "static/media/jSGD.68fa1877.png";